module.exports = __webpack_public_path__ + "img/check_mark.3ee5cce8.svg";